import React, { useContext, useEffect } from "react";
import Navbar from "../Shared/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../Shared/Footer";
import { DataContext } from "../Context/Context";
import Register from "../Components/Register";
import image from "../Assets/1.jpg";
import Login from "../Components/Login";
import "./style.css";
import whatsapp from "../Assets/whatsapp.png";
import NewFooter from "../Shared/NewFooter";
import DiscountModal from "../Components/DiscountModal";

const Main = () => {
  const { open } = useContext(DataContext);

  useEffect(() => {
    if (open) {
      // Disable scrolling
      document.body.style.overflow = "hidden";
    } else {
      // Enable scrolling
      document.body.style.overflow = "";
    }

    // Cleanup to ensure no residual styles
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className="relative">
      <dialog id="register_modal" className="modal">
        <div className="modal-box lg:h-[60%] md:h-[50%] h-[50%]  w-[100%] lg:min-w-[800px] flex p-0">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 z-50">
              ✕
            </button>
          </form>
          <div className="lg:w-[50%] md:w-[50%] w-full flex items-center">
            <Register />
          </div>
          <div className="g:w-[50%] md:w-[50%] w-full lg:block md:block hidden">
            <img src={image} alt="" className="h-full object-cover" />
          </div>
        </div>
      </dialog>
      <dialog id="login_modal" className="modal w-full">
        <div className="modal-box lg:h-[60%] md:h-[50%] h-[40%] w-[100%] lg:min-w-[800px] flex p-0">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 z-50">
              ✕
            </button>
          </form>
          <div className="lg:w-[50%] md:w-[50%] w-full flex items-center">
            <Login />
          </div>
          <div className="lg:w-[50%] md:w-[50%] w-full lg:block md:block hidden">
            <img src={image} alt="" className="h-full object-cover" />
          </div>
        </div>
      </dialog>
      <Navbar />
      <DiscountModal />
      <Outlet />
      {/* <Footer /> */}
      <NewFooter />
      <a
        href={"tel:+971521434186"}
        target="_blank"
        className="fixed bottom-6 right-4 z-50 w-14 h-14  inline-flex items-center justify-center rounded-full p-2 bg-[#b9a15d] text-white hover:text-slate-200 shadow-md cursor-pointer visited:text-white focus:text-white active:text-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width={32}
          height={32}
          className="text-inherit"
          fill={"none"}
        >
          <path
            d="M9.1585 5.71223L8.75584 4.80625C8.49256 4.21388 8.36092 3.91768 8.16405 3.69101C7.91732 3.40694 7.59571 3.19794 7.23592 3.08785C6.94883 3 6.6247 3 5.97645 3C5.02815 3 4.554 3 4.15597 3.18229C3.68711 3.39702 3.26368 3.86328 3.09497 4.3506C2.95175 4.76429 2.99278 5.18943 3.07482 6.0397C3.94815 15.0902 8.91006 20.0521 17.9605 20.9254C18.8108 21.0075 19.236 21.0485 19.6496 20.9053C20.137 20.7366 20.6032 20.3131 20.818 19.8443C21.0002 19.4462 21.0002 18.9721 21.0002 18.0238C21.0002 17.3755 21.0002 17.0514 20.9124 16.7643C20.8023 16.4045 20.5933 16.0829 20.3092 15.8362C20.0826 15.6393 19.7864 15.5077 19.194 15.2444L18.288 14.8417C17.6465 14.5566 17.3257 14.4141 16.9998 14.3831C16.6878 14.3534 16.3733 14.3972 16.0813 14.5109C15.7762 14.6297 15.5066 14.8544 14.9672 15.3038C14.4304 15.7512 14.162 15.9749 13.834 16.0947C13.5432 16.2009 13.1588 16.2403 12.8526 16.1951C12.5071 16.1442 12.2426 16.0029 11.7135 15.7201C10.0675 14.8405 9.15977 13.9328 8.28011 12.2867C7.99738 11.7577 7.85602 11.4931 7.80511 11.1477C7.75998 10.8414 7.79932 10.457 7.90554 10.1663C8.02536 9.83828 8.24905 9.56986 8.69643 9.033C9.14586 8.49368 9.37058 8.22402 9.48939 7.91891C9.60309 7.62694 9.64686 7.3124 9.61719 7.00048C9.58618 6.67452 9.44362 6.35376 9.1585 5.71223Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          ></path>
        </svg>
      </a>
      <a
        href={"https://wa.me/971523692378"}
        target="_blank"
        className="fixed bottom-24 right-4 z-50 w-14 h-14  inline-flex items-center justify-center rounded-full  text-white hover:text-slate-200 shadow-md cursor-pointer"
      >
        <img src={whatsapp} alt="" />
      </a>
    </div>
  );
};

export default Main;
